export default __webpack_public_path__ + "static/media/facebook-white.70a1490a.svg";